<template>
    <div>
        <div class="language">
            <a href="javascript:void(0)" class="flex" @click="openOptionsLanguages = !openOptionsLanguages" v-click-outside="hideLanguage">
                <img class="w-6 h-6" v-if="$root.currentLanguage !== undefined && $root.currentLanguage.length > 0" :src="require(`@/assets/image//${modifyLanguageCode($root.currentLanguage)}.svg`)" alt="">            
            </a>
            <div class="languages z-50" v-if="$root.languages" v-show="openOptionsLanguages" :class="[$root.hotelCode === 'courtyardpolyana'|| $root.hotelCode === 'courtyardkazan' ? 'left-0 z-10' : 'right-0']">
                <a href="javascript:void(0)" v-for="item in $root.languages" :key="item.code" @click="selectLanguage(item.code)">
                    <img class="w-6 h-6" :src="require(`@/assets/image//${modifyLanguageCode(item.code)}.svg`)" alt="">
                    <span>{{ item.code === 'il' ? 'HEB' : item.code }}</span></a>
            </div>
        </div>
    </div>
</template>

<script>
import { eventBus } from '../../../main';

export default {
    name: 'ArticleSelectLang',
    
    data() {
        return {
            openOptionsLanguages: false,
        }
    },

    methods: {
        async selectLanguage(lang_code) {
            this.$root.currentLanguage = lang_code;
            this.openOptionsLanguages = false;
            eventBus.$emit('change-language');

            const rtlLangs = ['ar', 'il', 'fa', 'ur'];
    
            // Get current state BEFORE any changes
            const htmlEl = document.querySelector("html");
            const currentDir = htmlEl.getAttribute("dir");
            const currentIsRtl = currentDir === "rtl";
            const newIsRtl = rtlLangs.includes(lang_code);
           
            this.$root.currentLanguage = lang_code;
            this.openOptionsLanguages = false;
            eventBus.$emit('change-language');
            
            if (currentIsRtl !== newIsRtl) {
                if (newIsRtl) {
                    htmlEl.setAttribute("dir", "rtl");
                } else {
                    htmlEl.removeAttribute("dir");
                }
                
                window.location.reload();
            } 
        },

        hideLanguage() {
            this.openOptionsLanguages = false;
        },

        modifyLanguageCode(code) {
            const site = this.$root.hotel.site
            const specialArabicSites = {
                'ibisstylessarajevo.dgstay.com': 'ar3',
                'swissotellivingjeddah.dgstay.com': 'ar5'
            }
            if(code == 'ar' && specialArabicSites[site]) {
                return specialArabicSites[site]
            }
            
            return code;
        },
    }
}
</script>